import React from 'react';
import Layout from '../Layout/Layout';
import {Block} from '../../styles/commons';
import PortalRecentMessageCenter from '../PortalRecentMessageCenter/PortalRecentMessageCenter'

const PortalRecentMessageScreen = props => {

  return (
    <Layout>
      <Block>
        <h1>Messages</h1>
        <h2>Select a message below to access that company's thread ...</h2>
        <PortalRecentMessageCenter sof={true} {...props}/>
      </Block>
    </Layout>
  );
};

export default PortalRecentMessageScreen;
